/*
  This is the summary error which will handle 404 catalog numbers
 */

import React, {useEffect} from 'react'
import Notice from '../Notice'
import { useSelector } from "react-redux";
import PropTypes from 'prop-types';
import store from "../../store/store"

const SummaryError = (props) => {
    const projectName = useSelector(state => state.projectName);
    const errors = useSelector(state => state.configuratorStateReducer.errors);

    if(!errors || errors.length == 0) {
        return null;
    }
    // // mount
    // useEffect(() => () => {
    //     store.dispatch({type: 'CLEAR_NOTICES'});
    // }, [])

    // useEffect(() => {
    //     store.dispatch({type: 'ADD_NOTICE', notice_type: 'catalog_number', message: props.error})
    // })


    const getProjectName = () => {
        if(projectName == null ){
            return;
        }

        return projectName
    }

    const errorMessage = () => {
        return <p><strong>ERROR:</strong>
            We're sorry, your selections result in an invalid configuration. Please verify your selections or contact the Fluxwerx Customer Service Team at 604-549-9379 or [<a href="mailto:serviceteam@fluxwerx.com">serviceteam@fluxwerx.com</a>] for assistance.</p>
    }

    
    return (
        <div className="row">
            <div className="small-12 columns">
                <div className="summary">
                    <div className="panel">
                        <h2>Summary - { getProjectName() } </h2>
                        <div className="row">
                            <Notice addPadding={true}/>
                            <div className="small-12 columns">
                                <p>Catalog Number:
                                </p>

                                { errorMessage() }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    
}

SummaryError.propTypes = {
    error: PropTypes.string
};

export default SummaryError;